import React from "react";

const SetupUsersIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37.966"
      height="37.292"
      viewBox="0 0 37.966 37.292"
    >
      <g
        id="Group_1270"
        data-name="Group 1270"
        transform="translate(-1164.518 -184.353)"
      >
        <path
          id="Path_1301"
          data-name="Path 1301"
          d="M296.046,392.271H258.08a18.18,18.18,0,0,1,18.161-18.161h1.644a18.18,18.18,0,0,1,18.161,18.161Z"
          transform="translate(906.438 -170.625)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1302"
          data-name="Path 1302"
          d="M338.825,261.991a9.117,9.117,0,1,1-9.117-9.118,9.118,9.118,0,0,1,9.117,9.118"
          transform="translate(853.791 -68.52)"
          fill={fill ? fill : "#ff7eb5"}
        />
      </g>
    </svg>
  );
};

export default SetupUsersIcon;
